import moment from "moment/moment";

const currency = (value) => {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
}

const formatDate = (value) => {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
}

const formatDateTime = (value) =>  {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY hh:mm')
    }
}

export { currency, formatDate, formatDateTime }
